import { Button, SelectBox, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import { ValueChangedEvent } from "devextreme/ui/select_box";
import React from "react";
import { areaService } from "../../api";
import { DataMap, enums } from "../../base";
import { AreaRef, CustomerRequestModel } from "../../models";

export interface CustomerRequestToolbarProps {
    permissions?: DataMap<boolean>;
    onButtonClick: (model: CustomerRequestModel, name: string) => void;
    onFiltering: (filterValue: any) => void;
}

interface CustomerRequestToolbarState {
    model: CustomerRequestModel;
    countyId?: number;
    streetId?: number;
    counties: AreaRef[];
    allStreets: AreaRef[];
    streets: AreaRef[];
}

export default class CustomerRequestToolbar 
    extends React.Component<CustomerRequestToolbarProps, CustomerRequestToolbarState> {
    constructor(props: Readonly<CustomerRequestToolbarProps>) {
        super(props);

        this.state = {
            model: {},
            counties: [],
            allStreets: [],
            streets: []
        };

        this.onCountyChanged = this.onCountyChanged.bind(this);
        this.onStreetChanged = this.onStreetChanged.bind(this);
        this.onFiltering = this.onFiltering.bind(this);
    }

    componentDidMount() {
        this.loadDataSources();
    }

    async loadDataSources() {
        let counties: AreaRef[] = [], streets: AreaRef[] = [];

        await Promise.all([
            (async () => counties = await areaService.getCounties())(),
            (async () => streets = await areaService.getStreets())(),
        ]);

        this.setState({
            counties: counties,
            allStreets: streets,
            streets: streets
        });
    }

    setModel(model: CustomerRequestModel) {
        this.setState({ model: model });
    }

    onCountyChanged(e: ValueChangedEvent) {
        const streets = e.value ?
            this.state.allStreets.filter(s => s.parentId === e.value) :
            this.state.allStreets;

        const streetId = streets.find(s => s.id === this.state.streetId) ? this.state.streetId : undefined;

        this.setState({
            countyId: e.value,
            streets: streets,
            streetId: streetId
        });
    }

    onStreetChanged(e: ValueChangedEvent) {
        this.setState({ streetId: e.value });
    }

    onFiltering() {
        this.props.onFiltering(this.getFilterValue());
    }

    private getFilterValue() {
        const filters: any[] = [];
        const { countyId, streetId } = this.state;

        if (countyId) {
            filters.push(["areaId", "=", countyId]);
        }
        if (streetId) {
            filters.push(["streetId", "=", streetId]);
        }

        return filters;
    }
    
    render() {
        const { model, countyId, counties, streets, streetId } = this.state;
        const permissions = this.props.permissions || {};
        const enabled = !!model.id && model.status === enums.customerRequestStatus.requested;

        return (
            <div className="page-toolbar">
                <Toolbar>
                <Item location={"before"} locateInMenu={"auto"}>
                        <SelectBox
                            value={countyId}
                            dataSource={counties}
                            displayExpr="name"
                            valueExpr={"id"}
                            showClearButton={true}
                            width={100}
                            placeholder="行政区域"
                            onValueChanged={this.onCountyChanged} />
                    </Item>
                    <Item location={"before"} locateInMenu={"auto"}>
                        <SelectBox
                            value={streetId}
                            dataSource={streets}
                            displayExpr="name"
                            valueExpr={"id"}
                            searchEnabled={true}
                            showClearButton={true}
                            width={120}
                            placeholder="街道"
                            onValueChanged={this.onStreetChanged} />
                    </Item>
                    <Item location={"before"} locateInMenu="false">
                        <Button
                            text="查询"
                            type="default"
                            onClick={this.onFiltering} />
                    </Item>
                    <Item location="after" locateInMenu="auto" visible={!!permissions["Assign"]}>
                        <Button
                            text="分配站点"
                            disabled={!enabled}
                            onClick={() => this.props.onButtonClick(model, "assign")} />
                    </Item>
                    <Item location="after" locateInMenu={"auto"} visible={!!permissions["CreateCustomer"]}>
                        <Button
                            text="创建客户"
                            disabled={!enabled}
                            onClick={() => this.props.onButtonClick(model, "customer")} />
                    </Item>
                    <Item location={"after"} locateInMenu="auto" visible={!!permissions[enums.stdActions.delete]}>
                        <Button
                            text="作废该申请"
                            disabled={!enabled}
                            onClick={() => this.props.onButtonClick(model, "discard")} />
                    </Item>
                </Toolbar>
            </div>
        )
    }
}